// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__ZAtyf","header":"MessagesList_header__1yOuR","chat":"MessagesList_chat__1ui5p"};